import { __decorate } from "tslib";
/*global document */
import * as CONST from '../const';
import Reportable from '../decorators/reportable';
import EventEmitter from 'events';
import UICommon from './common';
import UIQuery from './query';
import UserForm from './form';
import UIFixedPrice from './fixed.price';
import UIWrapper from './wrapper';
import FormElementTooltip from './form.el.tooltip';
import StepRendererSelector from './step.renderer.selector';
import FormElementDigitalRenderer from './form.el.digital';
import UIOverlay from './overlay';
import UIPreview from './preview';
import UIUploader from './uploader';
import UIPreviewCloseup from './closeup';
const DEFAULT_OPTIONS = {
    targetId: 'calculator',
    uniqueId: '',
    renderForm: true,
    preserveFormat: true,
    paspartuOverflow: true,
    overlay: true,
    startUnder: false,
    currencySign: false
};
class CalculatorUI extends EventEmitter {
    CONTAINER_TYPE = 'main';
    options = { ...DEFAULT_OPTIONS };
    form;
    wrapper;
    bagetPricesCache = new Map();
    overlayMain;
    preview;
    closeup;
    uploader;
    fixedPrice;
    query;
    parentEl;
    calculator;
    project;
    uis = {};
    constructor(options, calculator, project, uis) {
        super();
        Object.assign(this.options, options);
        if (this.options.currencySign !== false) {
            UICommon.setCurrencySign(this.options.currencySign);
        }
        if (this.options.currencyPostfix !== false && typeof this.options.currencyPostfix !== 'undefined') {
            UICommon.setCurrencyPostfix(this.options.currencyPostfix);
        }
        this.calculator = calculator;
        this.project = project;
        this.query = new UIQuery(this.options.uniqueId);
        StepRendererSelector.init(this);
        this.form = new UserForm(this);
        this.wrapper = new UIWrapper(this);
        if (this.options.uis) {
            if (this.options.uis.preview !== false) {
                this.preview = new UIPreview(this, project, calculator);
            }
            if (this.options.uis.closeup !== false) {
                this.closeup = new UIPreviewCloseup(this, project);
            }
        }
        if (uis) {
            Object.keys(uis).forEach((uiKey) => {
                this.uis[uiKey] = new uis[uiKey].component(this, project, calculator, uis[uiKey].options);
            });
        }
        this.uploader = new UIUploader(this, project);
        this.fixedPrice = new UIFixedPrice(this, project);
        this.bindEvents();
        this.updateUIFromSummary();
    }
    getQuery() {
        return this.query;
    }
    getTargetId() {
        return this.options.targetId;
    }
    getUniqueId() {
        return this.options.uniqueId;
    }
    bindEvents() {
        this.project.on('total.changed', (val) => {
            console.log('event: total.changed', val);
            this.updateTotalPriceTag(val);
            this.updateFormProjectPriceValue(val);
        });
        this.project.on('propertyRemoved', (val) => {
            console.log('event: project property removed:', val.property);
            this.unsetProperty(val.property);
        });
        this.project.on('propertyAdded', (val) => {
            console.log('event: project property added:', val.property);
            this.setProperty(val.property, val.value);
        });
        this.project.on('propertyHided', (val) => {
            console.log('event: project property hided:', val.property);
            this.hideProperty(val.property);
        });
        this.project.on('propertyShowed', (val) => {
            console.log('event: project property showed:', val.property);
            this.showProperty(val.property);
        });
        this.project.on('summary.changed', (val) => {
            console.log('event: project summary changed:', val);
            this.updateFormProjectSummaryValue(val);
        });
        this.project.on('price.changed.baget', (val) => {
            console.log('event: baget price changed:', val);
            this.updateFormBagetPriceValue(val);
        });
        this.calculator.getAllAvailableProperties().forEach((name) => {
            this.project.on(`price.changed.${name}`, (val) => {
                console.log(`event: price.changed.${name}`, val);
                this.updatePropertyPriceTag(val);
            });
        });
        this.project.on('digital', () => {
            this.hideMaterialOptions();
        });
        this.project.on('material', () => {
            this.showMaterialOptions();
        });
    }
    render() {
        this.removeLoaderPlaceholder();
        if (this.options.overlay) {
            this.updateTargetElement();
            this.renderOverlay();
        }
        //this.renderWrapper();
        this.renderSteps();
        if (this.options.renderForm) {
            this.renderForm();
            this.project.updateSummary();
        }
        if (this.preview) {
            this.preview.render();
        }
        if (this.uploader) {
            this.uploader.render(this.getContainerElement());
        }
        if (this.fixedPrice) {
            this.fixedPrice.render();
        }
        if (this.uis) {
            Object.keys(this.uis).forEach(key => {
                this.uis[key].render(this.getContainerElement());
            });
        }
        this.updateUIFromSummary();
    }
    removeLoaderPlaceholder() {
        const loader = document.querySelector(`.calc-loader[data-name="${this.calculator.getName()}"]`);
        if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader);
        }
    }
    isInOverlay() {
        return this.options.overlay;
    }
    isInMobile() {
        return this.options.overlay;
    }
    updateTargetElement() {
        const el = document.querySelector(`#${this.options.targetId}`);
        if (el && el.parentNode) {
            this.parentEl = el.parentNode;
            //cleanin inside of parent of trigger
            while (this.parentEl.firstChild) {
                this.parentEl.removeChild(this.parentEl.firstChild);
            }
        }
    }
    getName() {
        return this.calculator.getName();
    }
    getOptions() {
        return this.options;
    }
    createSeparator() {
        const el = document.createElement('div');
        el.innerHTML = '&nbsp;';
        return el;
    }
    createEmptyStep(addClass) {
        const el = document.createElement('div');
        el.classList.add('row');
        if (addClass) {
            el.classList.add(addClass);
        }
        return el;
    }
    getStepsContainer() {
        return this.query.one(`.${CONST.CLASS_PREFIX}steps`);
    }
    renderSteps() {
        let len = 0, block = this.getStepsContainer(), wholeLine = ['baget', 'size'], cont = this.createEmptyStep(), steps = this.calculator.getSteps();
        if (!block) {
            return;
        }
        for (let t = 0; t < steps.length; t++) {
            const step = steps[t], renderer = this.getRendererForStep(step);
            if (wholeLine.indexOf(step.optionName) !== -1) {
                if (t > 0) {
                    //block.appendChild(this.createSeparator());
                }
                cont = this.createEmptyStep();
                block.appendChild(cont);
            }
            else {
                if ((len % 2 === 0) && (len > 0)) {
                    //block.appendChild(this.createSeparator());
                    cont = this.createEmptyStep();
                    block.appendChild(cont);
                }
                len++;
            }
            renderer.render(step, cont, 2 + t);
        }
        if (this.calculator.isDigital()) {
            const cont = this.createEmptyStep('digital');
            block.appendChild(cont);
            this.renderDigitalSwitch(cont, 2 + steps.length);
            block.appendChild(this.createSeparator());
        }
    }
    renderDigitalSwitch(cont, index) {
        const digitalSwitchEl = new FormElementDigitalRenderer(this);
        digitalSwitchEl.render(cont, index);
    }
    getRendererForStep(step) {
        return StepRendererSelector.getRenderer(step);
    }
    getContainerElement() {
        const cont = document.querySelector('#' + this.options.targetId);
        if (cont) {
            return cont;
        }
        throw new Error('Main container is not found');
    }
    renderWrapper() {
        this.wrapper.render();
    }
    renderTooltip(tooltip) {
        FormElementTooltip.render(tooltip);
    }
    renderForm() {
        this.form.render();
    }
    renderPreview() {
        this.preview && this.preview.render();
    }
    updateOrderInfo() {
        if (!this.getQuery()) {
            return;
        }
        const el = this.getQuery().one('input[name="order-add-info"]', 'main');
        if (!el) {
            return;
        }
        el.value = this.encodeOrderInfoLine();
    }
    encodeOrderInfoLine() {
        return ''; //this.getProjectInfo() + "\n Сообщение: " + this.getUserInfo() + this.getReferenceInfo();
    }
    /*
    getProjectInfo():string{
          let text = '';
          let obj = this.getProjectInfoAsArray();
          obj.forEach(item => {
              text += `${item.title}: ${item.value}` + "\n";
          });
          return text;
      }
  
    getProjectInfoAsArray() {
          let result = [];
      if (this.project){
        let summary = this.project.getSummary();
        if(!summary.digital){
          result.push({title: 'Цифровой макет', value: 'Нет'});
          result.push({title: 'Ширина', value: summary.width});
          result.push({title: 'Высота', value: summary.height});
        }else{
          result.push({title: 'Цифровой макет', value: 'Да'});
        }
        result.push({title: 'Число лиц', value: summary.facesCount});
        for(let optionName in summary.properties){
          let variant = summary.properties[optionName];
          let human = {
            title: this.calculator.getOptionTitle(optionName),
            value: this.calculator.getOptionValueTitle(optionName, variant.value),
          };
          result.push({
            option: optionName,
            ...variant,
            human
          });
        }
      }
          return result;
      }
  
      getUserInfo() {
          if (this.options.renderForm) {
              return this.getContainerElement().querySelector('textarea[name="order-add-info-user"]').value;
          } else {
              return '';
          }
      }
  
      getReferenceInfo() {
          if (this.reference) {
              return "\n Референс картинка: (" + this.reference + ") - Внимание! Открывайте ссылку только если она ведёт на картинку на сервере muse.ooo, иначе возможны угрозы безопасности.";
          } else {
              return '';
          }
      }
  */
    showCloseup() {
        this.closeup.render();
        this.preview && this.preview.renderCloseup();
    }
    onListChange(property, id) {
        this.project.changeProperty(property, id);
    }
    onFacesListChange(id) {
        this.project.changeFacesCount(id);
    }
    onBagetChange(id) {
        if (id > 0) {
            this.project.changeProperty('baget', id);
        }
        else {
            this.project.removeProperty('baget');
        }
    }
    onCheckboxChange(property, id, status) {
        if (status) {
            this.project.changeProperty(property, id);
        }
        else {
            this.project.removeProperty(property);
        }
    }
    onDigitalChange(status) {
        if (status) {
            this.project.setDigital();
        }
        else {
            this.project.setMaterial();
        }
    }
    onFreeSizeWidthChange(val) {
        this.project.changeWidth(val);
        return this.project.getImageQuality();
    }
    onFreeSizeHeightChange(val) {
        this.project.changeHeight(val);
        return this.project.getImageQuality();
    }
    changeProjectProperty(property, value) {
        this.project.changeProperty(property, value);
    }
    removeProjectProperty(property) {
        this.project.removeProperty(property);
    }
    setDefaultProjectProperty(property) {
        this.project.setPropertyToDefault(property);
    }
    renderOverlay() {
        if (typeof this.overlayMain === 'undefined') {
            const options = {
                data: {
                    'calculatorId': this.getUniqueId()
                },
                containerId: `calculator-container-${this.CONTAINER_TYPE}`,
                contentId: this.options.targetId,
                layer: CONST.MAIN_LAYER,
                parentEl: this.parentEl,
                startUnder: this.options.startUnder,
                over: !this.options.startUnder,
                underlayer: CONST.UNDER_LAYER
            };
            this.overlayMain = new UIOverlay(options);
            this.overlayMain.render();
        }
    }
    updatePropertyPriceTag(val) {
        const { property, price } = val;
        const els = this.query.all(`#option_${property} .price`);
        if (els) {
            Array.from(els).forEach(el => this.setPriceElementContent(el, price));
        }
    }
    setPriceElementContent(el, price) {
        const priceStr = UICommon.formatPrice(price);
        if (priceStr === '') {
            el.classList.add(CONST.OPT_CLASS_HIDDEN);
        }
        else {
            el.classList.remove(CONST.OPT_CLASS_HIDDEN);
            el.innerHTML = priceStr;
        }
    }
    replacePriceInElements(selector, price) {
        const priceEls = this.query.all(`${selector}`);
        if (priceEls && priceEls.length) {
            priceEls.forEach(el => this.setPriceElementContent(el, price));
        }
    }
    updateTotalPriceTag(price) {
        const originalPrice = Math.round(price / ((100 - this.getPriceOff()) / 100));
        this.replacePriceInElements(`.${CONST.CLASS_PREFIX}price`, price);
        this.replacePriceInElements(`.${CONST.CLASS_PREFIX}price_original`, originalPrice);
    }
    getPriceOff() {
        const priceoff = this.calculator.getDiscount();
        if (isNaN(priceoff) || (priceoff === 0)) {
            return CONST.PRICE_OFF;
        }
        else {
            return priceoff;
        }
    }
    getPropertyPrice(property) {
        return this.project.getPropertyPrice(property);
    }
    onPropertyPriceChange(property, callback) {
        this.project.on(`price.changed.${property}`, ({ price }) => callback(price));
    }
    unsetProperty(property) {
        const el = this.query.one(`#option_${property} input[type="checkbox"]`);
        if (el) {
            el.checked = false;
        }
    }
    setProperty(property, value) {
        const el = this.query.one(`#option_${property} input[type="checkbox"]`);
        if (el) {
            el.checked = !!value;
        }
    }
    showProperty(property) {
        const el = this.query.one(`#option_${property}`);
        if (el) {
            el.style.display = 'block';
        }
    }
    hideProperty(property) {
        const el = this.query.one(`#option_${property}`);
        if (el) {
            el.style.display = 'none';
        }
    }
    updateBagetsPrices(prices) {
        this.bagetPricesCache = prices;
    }
    getActivePropertyValue(property) {
        return this.project.getActivePropertyValue(property);
    }
    getBagetPrice(id) {
        if (this.bagetPricesCache.has(`${id}`)) {
            const price = this.bagetPricesCache.get(`${id}`);
            if (price) {
                return price;
            }
        }
        return 0.0;
    }
    hideMaterialOptions() {
        this.query.findAllAndUpdateStyle('.scrollBlock>.row>div:not(.digital), .scrollBlock>div:not(.row)', new Map([['display', 'none']]));
    }
    showMaterialOptions() {
        UICommon.findAllAndUpdateStyle('.scrollBlock>.row>div:not(.digital), .scrollBlock>div:not(.row)', new Map([['display', 'block']]));
    }
    getProject() {
        return this.project;
    }
    getPreview() {
        return this.preview;
    }
    updateFormProjectPriceValue(val) {
        if (this.options.renderForm) {
            this.form.setProjectPrice(val);
        }
    }
    updateFormProjectSummaryValue(val) {
        if (this.options.renderForm) {
            this.form.setProjectSummary(val);
        }
    }
    updateFormBagetPriceValue(val) {
        if (this.options.renderForm) {
            this.form.setBagetPrice(val);
        }
    }
    scrollIntoView(delay = 600) {
        setTimeout(() => {
            this.getContainerElement().scrollIntoView({
                block: 'end',
                behavior: 'smooth'
            });
        }, delay);
    }
    updateUIFromSummary() {
        const steps = this.calculator.getSteps();
        const summary = this.project.getSummary();
        steps.forEach((step) => {
            const renderer = this.getRendererForStep(step);
            try {
                renderer.updateFromSummary(step, summary);
            }
            catch (e) {
                console.error(e.message, step.optionModel, step.optionName);
            }
        });
    }
}
__decorate([
    Reportable
], CalculatorUI.prototype, "bindEvents", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "render", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getName", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getOptions", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "createSeparator", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "createEmptyStep", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getStepsContainer", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderSteps", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderDigitalSwitch", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getRendererForStep", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getContainerElement", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderWrapper", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderTooltip", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderForm", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderPreview", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "updateOrderInfo", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "showCloseup", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onListChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onFacesListChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onBagetChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onCheckboxChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onDigitalChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onFreeSizeWidthChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onFreeSizeHeightChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "changeProjectProperty", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "removeProjectProperty", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "setDefaultProjectProperty", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "renderOverlay", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "updatePropertyPriceTag", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "setPriceElementContent", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "replacePriceInElements", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "updateTotalPriceTag", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getPriceOff", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "getPropertyPrice", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "onPropertyPriceChange", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "unsetProperty", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "setProperty", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "showProperty", null);
__decorate([
    Reportable
], CalculatorUI.prototype, "hideProperty", null);
export default CalculatorUI;
